<template>
  <section class="bbt-content">
    <div class="question" v-html="question.question" />
    <component
      v-if="question.code"
      color="secondary lighten-5"
      :is="interactionType"
      :items="question.items"
      :matches="question.matches"
      :value="value"
      @input="input"
    />
  </section>
</template>
<script>
import '../../assets/content.css'
import Interaction1OfN from './Interactions/1ofN'
import InteractionMOfN from './Interactions/MofN'
import InteractionSequence from './Interactions/Sequence'
import InteractionMatch from './Interactions/Match'
import InteractionInline from './Interactions/Inline'
export const questionType = {
  '1ofN': 0,
  MofN: 1,
  sequence: 2,
  match: 3,
  inline: 4
}

export default {
  name: 'Question',
  props: {
    question: {
      type: Object,
      required: true
    },
    value: {
      type: String,
      required: true
    }
  },
  computed: {
    interactionType() {
      switch (this.question.type) {
        case questionType['1ofN']:
        default:
          return Interaction1OfN
        case questionType.MofN:
          return InteractionMOfN
        case questionType.sequence:
          return InteractionSequence
        case questionType.match:
          return InteractionMatch
        case questionType.inline:
          return InteractionInline
      }
    }
  },

  methods: {
    input(value) {
      this.$emit('input', value)
    }
  }
}
</script>
